<template>
  <button class="button" :disabled="isDisabled" :class="[{active: isLoading}]">
    <ui-loader class="button__loader" v-if="isLoading" />
    <slot v-else />
  </button>
</template>

<script setup>
import UiLoader from "@/components/ui/ui-loader.vue";

const props = defineProps({
  isDisabled: Boolean,
  isLoading: Boolean
})
</script>

<style lang="scss" scoped>
.button {
  position: relative;
  width: 100%;
  cursor: pointer;
  border-radius: 10px;
  background: linear-gradient(84deg, #FF6162 0%, #EB5393 68%, #F4915D 100%);
  flex-shrink: 0;
  transition: 0.2s;
  padding: 15px 30px;
  z-index: 1;

  color: $white;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  line-height: 18px;

  &:hover, &.active {
    color: $white;
  }
  
  @include hover {
    background: linear-gradient(84deg, #F75B74 0%, #EE558D 68%, #EF6B7F 100%);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &__loader {
    margin-bottom: 10px;
  }
}
</style>